import { areDeepEqualObjectUtil, omitObjectUtil } from '../../../object'

export default function arePropsEqualComponentUtil ({
  keysToIgnore = []
} = {}) {
  return (prevProps, nextProps) => {
    if (
      nextProps.isFocused != null &&
      !nextProps.isFocused
    ) {
      return false
    }

    const prevPropsFiltered = omitObjectUtil(prevProps, keysToIgnore)
    const nextPropsFiltered = omitObjectUtil(nextProps, keysToIgnore)
    const areDeeplyEqual = areDeepEqualObjectUtil(
      prevPropsFiltered,
      nextPropsFiltered
    )
    // const diff = getDeepDiffObjectUtil(
    //   prevPropsFiltered,
    //   nextPropsFiltered
    // )

    // const debugProps = {
    //   prevPropsFiltered,
    //   nextPropsFiltered,
    //   diff,
    //   areDeeplyEqual
    // }

    // logSystemUtil('arePropsEqualComponentUtil').debug('debugProps=', debugProps)
    return areDeeplyEqual
  }
}
